import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { reports: () => import('./ReportsPage.vue') },
} satisfies FeatureRoutes
